// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"Artists_headerBar__37pmM","button":"Artists_button__2T6Tv"};